import { Component, OnInit, Input } from '@angular/core';
import { GetService } from '../../dataservice/get.service';

/**
 * Import language service.
 */
import { LanguageService } from '../../dataservice/language.service';

/**
 * Share profile component.
 */
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  /**
   * Input referal id.
   */
  @Input() referal_id;

  /**
   * Input product type.
   */
  @Input() product_type;

  /**
   * Input product type id.
   */
  @Input() product_type_id: any;

  /**
   * Chek if api is loaded or not.
   */
  public finished = false;
  /**
   * Chek if data is recived or not.
   */
  public is_res_received = false;
  /**
   * Chek if there is data or not.
   */
  public no_recfound = false;

  /**
   * Store profile data.
   */
  public profileData: {
    profile_pic: string,
    registered_name: string
  };

  /**
   * Profile api eror message.
   */
  public profileErrorMsg: string;

  /**
   * Get api serice.
   */
  constructor(private getApiService: GetService, public mls: LanguageService) {
  }

  /**
   * Initiate get profile data.
   */
  ngOnInit() {
    this.getProfileDeatil();
  }

  /**
   * Get profile data.
   */
  getProfileDeatil(): void {
    if (this.getApiService.is_login == '1') {
      this.getApiService.navigateToSection(14, this.product_type_id);
    }
    this.getApiService.getProfileData(this.product_type_id).subscribe(data => {
      this.finished = true;
      if (data['status'] == 1) {
        this.profileData = data['data'].profiles;
      } else {
        this.no_recfound = true;
        this.profileErrorMsg = data['error'].msg;
      }
    });
  }

  /**
   * Navigate user to profile page.
   */
  navigateto(): void {
    this.getApiService.navigateToSection(14, this.product_type_id);
  }
}
